import axios from 'axios'

const BASE_API = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH

// class XLResponse{
//     constructor(code,data,msg){
//         this.code = code;
//         this.data = data;
//         this.msg = msg;
//     }

//     success(){
//         return this.code == CODE_SUCCESS
//     }
// }

let http = axios.create({
  baseURL: BASE_API,
  timeout: 9000,
  headers: {
    token: localStorage.getItem('token'),
    cid: localStorage.getItem('cid')
    // 'Content-Type':'application/json'
  }
})
import router from './../router'
import { XLToastError } from './toast'
import { APICODE } from './constant'
const READ_ONLY_POST_WHITELIST = ['account/changedPwd', 'login/admin']

// 写入 cost 表的入账类接口：相同参数在请求未结束前拒绝重复提交
const DUPLICATE_POST_GUARD_URLS = [
  // 订单：收款、垫付、退款、押金/其他费用、自动收款、以租代购完成
  'order/shouKuan',
  'order/dianFu',
  'order/deposit',
  'order/tuiKuan',
  'order/autoSK',
  'order/giveBikeOver',
  // 日常统计
  'day/add',
  // 车辆：日常统计、售卖（售卖可能间接写入 cost）
  'bike/day',
  'bike/add',
  'bike/sell',
  'bike/settlePurchase',
  'bike/rebate',
  'bike/collectSellPayment',
  'bike/settleSellCommission',
  'bike/revokeSellCommission',
  'commission/pay'
]

const inflightPostKeys = new Set()

function isDuplicateGuardUrl(url) {
  return DUPLICATE_POST_GUARD_URLS.some((item) => url.includes(item))
}

function stableStringify(value) {
  if (value === undefined) {
    return 'null'
  }
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value)
  }
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`
  }
  const sortedKeys = Object.keys(value).sort()
  return `{${sortedKeys.map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`
}

function buildPostGuardKey(url, data) {
  const payload = data && typeof data === 'object' ? data : {}

  // 订单期数类入账：同一 numId 进行中只允许一次（连点参数可能略有差异）
  if (url.includes('order/shouKuan') || url.includes('order/dianFu') || url.includes('order/tuiKuan')) {
    return `${url}#numId:${payload.numId}`
  }
  if (url.includes('order/deposit')) {
    return `${url}#orderId:${payload.orderId}#cate:${payload.cate}`
  }
  if (url.includes('order/giveBikeOver')) {
    return `${url}#orderId:${payload.orderId}`
  }
  if (url.includes('bike/sell')) {
    return `${url}#bikeId:${payload.id}`
  }

  return `${url}:${stableStringify(payload)}`
}

function acquirePostGuard(url, data) {
  if (!isDuplicateGuardUrl(url)) {
    return { acquired: true, guardKey: null }
  }

  const guardKey = buildPostGuardKey(url, data)
  if (inflightPostKeys.has(guardKey)) {
    return { acquired: false, guardKey: null }
  }

  inflightPostKeys.add(guardKey)
  return { acquired: true, guardKey }
}

function needLogin() {
  localStorage.removeItem('token')
  localStorage.removeItem('readOnlyUser')
  router.push({
    name: 'login'
  })
}

export function saveToken(token) {
  localStorage.setItem('token', token)
  http.defaults.headers['token'] = token
}

export function saveCompanyId(cid) {
  localStorage.setItem('cid', cid)
  http.defaults.headers['cid'] = cid
}

export function APIPOST(url, data) {
  return new Promise((resolve, reject) => {
    const isReadOnlyUser = localStorage.getItem('readOnlyUser') == '1'
    const allowReadOnlyPost = READ_ONLY_POST_WHITELIST.some((item) => url.includes(item))
    if (isReadOnlyUser && !allowReadOnlyPost) {
      XLToastError('只读角色无新增、修改、删除权限！')
      resolve({
        code: -1,
        msg: '只读角色无新增、修改、删除权限！',
        data: null
      })
      return
    }

    const guardResult = acquirePostGuard(url, data)
    if (!guardResult.acquired) {
      XLToastError('请勿重复提交，请稍候')
      resolve({
        code: -1,
        msg: '请勿重复提交，请稍候',
        data: null
      })
      return
    }

    const guardKey = guardResult.guardKey

    const releaseGuard = () => {
      if (guardKey) {
        inflightPostKeys.delete(guardKey)
      }
    }

    http
      .post(url, data)
      .then((res) => {
        let data = res.data
        if (data.code == APICODE.NEED_LOGIN) {
          needLogin()
        } else if (data.code != APICODE.SUCCESS) {
          XLToastError(data.msg)
        }
        resolve(data)
      })
      .catch(() => {
        XLToastError('服务器内部出错！')
        reject('服务器内部出错！')
      })
      .finally(releaseGuard)
  })
}
export function APIGET(url, data) {
  return new Promise((resolve, reject) => {
    http
      .get(url, { params: data })
      .then((res) => {
        let data = res.data
        if (data.code == APICODE.NEED_LOGIN) {
          needLogin()
        } else if (data.code != APICODE.SUCCESS) {
          XLToastError(data.msg)
        }
        resolve(data)
      })
      .catch((error) => {
        if (url == 'userAdmin/info') {
          resolve('data')
        } else {
          XLToastError('服务器内部出错！')
          console.log('请求错误：', error)
          reject('服务器内部出错！')
        }
      })
  })
}
/** 获取 本地 文件 */
export function APIPUBLIC(url, data) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, data)
      .then((res) => {
        let data = res.data
        resolve(data)
      })
      .catch(() => {
        reject('服务器内部出错！')
      })
  })
}
